import React from "react";
import { errorBoundaryFallback } from "../../../locales/en";
function ComponentViewFallback() {
  const handleReload = (e) => {
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    window.location.reload();
  };

  return (
    <div className="text-center mt-50">
      <h4>{errorBoundaryFallback.tableFallback.text1}</h4>

      <a href="#" onClick={handleReload}>
        <strong>{errorBoundaryFallback.tableFallback.reloadLink}</strong>
      </a>

      <span>{` ${errorBoundaryFallback.tableFallback.text2} `}</span>
    </div>
  );
}

export default ComponentViewFallback;
